<section class="job-filters-section">
    <div class="">
            <div class="d-flex">
                <div class="filters-heading me-2">Filters</div>
                <mat-chip class="reset-chip" (click)="resetFilters()"><img src="/assets/images/job-filters-reset.svg" alt="job-filters-reset" class="me-1" />Reset</mat-chip>
            </div>

            <div class="">
            <div class="card mt-3">
             <div class="card-body scrollable-container" >
                    <form [formGroup]="filterForm">
                        <div class="filter-field-container">
                            <div class="filter-label mb-3">Explore Manufacturers</div>                        
                <mat-chip-grid #chipList>
                  <mat-chip-row *ngFor="let keyword of keywords" class="reset-chip" [selectable]="selectable" [removable]="removable" (removed)="removeKeyword(keyword)">
                    {{ keyword | truncateText: 8 }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <div *ngFor="let controlName of filterControls">
                    <mat-chip-row *ngFor="let item of filterForm.get(controlName)?.value" class="reset-chip"
                      [selectable]="selectable" [removable]="removable" (removed)="remove(controlName, item)">
                      {{controlName === 'distributorId' || controlName === 'categoryId' ? item.name  : controlName === 'currency' || controlName === 'turnOver' ? (item.label | truncateText: 8) : (item | truncateText: 8)}}
                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip-row>
                  </div>
                  <div class="input-wrapper" style="position: relative;" #searchContainer>
                    <label class="input-container w-100">
                      <mat-icon matPrefix class="inp">search</mat-icon>
                      <input matInput [matChipInputFor]="chipList" placeholder="Search By Keyword"
                      [value]="textFromUniversalSearch ? textFromUniversalSearch : ''"
                        (matChipInputTokenEnd)="add($event)" (input)="searchSuggestionDebouncer($event)" autocomplete="off"
                        (click)="toggleSuggestions(); $event.stopPropagation()" />
                                </label>
                                <div *ngIf="isSugestionOpen" class="search-suggestions">
                                    <ul>
                                        <li *ngFor="let suggestion of searchSuggestions">
                                            <p (click)="selectedSuggestion(suggestion)">{{ suggestion.name }}</p>
                                        </li>
                                    </ul>
                                </div>
                                </div>
                            </mat-chip-grid>
                        </div>

                        <div class="filter-field-container">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Region</mat-panel-title>
                     </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input #autoCompleteInput matInput [matAutocomplete]="countryAuto" placeholder="Search for country"
                      [formControl]="countryControl" />
                    <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'country')">
                      <mat-option *ngFor="let country of filteredCountries" [value]="country">
                        {{ country.countryName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput #autoCompleteInput [matAutocomplete]="stateAuto" placeholder="Search for state" [formControl]="stateControl" />
                    <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'state')">
                      <mat-option *ngFor="let state of filteredStates" [value]="state">
                        {{ state.stateName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input #autoCompleteInput matInput [matAutocomplete]="cityAuto" placeholder="Search for city"
                      [formControl]="cityControl" />
                    <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'city')">
                      <mat-option *ngFor="let city of filteredCities" [value]="city">
                        {{ city.cityName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput placeholder="Filter By Zip Code" formControlName="postalCode" />
                  </mat-form-field>
                </mat-expansion-panel>
              </div>
              <div class="filter-field-container">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Distributors</mat-panel-title>
                              </mat-expansion-panel-header>
                              <mat-form-field appearance="outline" class="input-font w-100">
                                <input matInput [matAutocomplete]="brandsAuto" placeholder="Search for Distributors"
                                  [formControl]="distributorControl" />
                                <mat-autocomplete #brandsAuto="matAutocomplete"
                                  (optionSelected)="onOptionSelected($event, 'distributor')">
                                  <mat-option *ngFor="let distributor of filteredDistributors" [value]="distributor">
                                    {{ distributor.name }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </mat-expansion-panel>
                        </div> 

                        <div class="filter-field-container">
                            <mat-expansion-panel>
                               <mat-expansion-panel-header>
                                 <mat-panel-title class="filter-label">Years in Market</mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-slider min="0" max="100" class="w-100">
                                    <input formControlName="yearFrom" matSliderStartThumb>                       
                                   <input formControlName="yearTo" matSliderEndThumb>
                              </mat-slider>
                              <p>
                                {{filterForm.get('yearFrom')?.value || 0}} -{{filterForm.get('yearTo')?.value || 0}} Years</p>
                            </mat-expansion-panel>
                        </div>
              <div class="filter-field-container">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Turn Over</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="filter-content">
                    <mat-form-field appearance="outline" class="input-font w-100">
                      <input matInput [matAutocomplete]="symbolAuto" placeholder="$ - USD"
                        [formControl]="currencySymbolControl" />
                      <mat-autocomplete #symbolAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'symbol')">
                        <mat-option *ngFor="let symbol of filteredCurrencySymbols" [value]="symbol.label">
                          {{ symbol.label }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
  
                    <mat-form-field appearance="outline" class="input-font w-100">
                      <input #valueAutoCompleteInput matInput [matAutocomplete]="valueAuto" placeholder="Budget range"
                        [formControl]="amountRangeControl" />
                      <mat-autocomplete #valueAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'range')"
                        [displayWith]="displayLabel">
                        <mat-option *ngFor="let range of amountRange" [value]="range">
                          {{ range.label }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </mat-expansion-panel>
              </div>
  
              <div class="filter-field-container">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Category</mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput [matAutocomplete]="categoriesAuto" placeholder="Search for Categories"
                      [formControl]="categoryControl" />
                    <mat-autocomplete #categoriesAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'category')">
                      <mat-option *ngFor="let category of filteredCategories" [value]="category">
                        {{ category.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-expansion-panel>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</section>